import { Pipe, PipeTransform } from '@angular/core';
import toNumber from 'lodash-es/toNumber';

@Pipe({ name: 'skeletonScreenPipe', pure: true })
export class SkeletonScreenPipe implements PipeTransform {
  transform = (times?: string | number): number[] => new Array(toNumber(times));
}
